import {BehaviorSubject} from "rxjs";

export enum LockStatus {
    Initializing  = "Initializing", // Startup Status
    Unclaimed = "Unclaimed", // Not Locked, Available
    Locked   = "Locked",  // Exclusive Owner
    ReadOnly = "ReadOnly", // Locked by Someone Else
    Disconnected = "Disconnected", // Disconnected from Server
}

export interface ILockObject {
    UI_Id: string,
    Name: string
}

export interface ILockOwner {
    OwnerName: string,
    SessionId: string,
    HostName: string
}

export interface ILockPropertyChangeEvent {
    Lock: ILock,
    PropertyChanged: string,
    PropertyValue: any

}

export interface ILockAcquireResponse {
    bSuccess: boolean,
    sFailureReason: string
}

export interface ILock {

    readonly Key: string, // assigned by the server
    readonly ClassId: string,
    readonly LockId: string | number,

    readonly bLoaded: boolean
    OnLoaded(): Promise<void>

    readonly bStatusOnly: boolean
    readonly Object: ILockObject
    readonly Status: LockStatus
    readonly Owner: ILockOwner,
    readonly OwnerCreateTS: Date

    readonly LastAccessTS: Date
    readonly ExpiresOnTS: Date


    readonly OnPropertyChanged: BehaviorSubject<ILockPropertyChangeEvent>

    acquire(sTimeoutSeconds?: number): Promise<ILockAcquireResponse>
    release(sTimeoutSeconds?: number): Promise<void>
    touch(sTimeoutSeconds?: number): Promise<void>
    destroy(): Promise<void>

}

export interface ILockCollection {
    [classId: string]: {[lockId: string]: ILock}
}

export interface ILockClassSummaryCollection {
    [classId: string]: {classId: string, className: string, lockCount: number}
}

export interface ILockOptions {
    object?: ILockObject,
    bTryAcquire?: boolean,
    bStatusOnly?: boolean
}


export interface ILockServiceClient {
    //-- User API
    //-- Editable Locks (can be acquired, released)
    createLock(classId: string, lockId: number| string, options?: ILockOptions): ILock
    createLocks(classId: string, lockIds: (number | string)[], options?: ILockOptions): ILock[]

    //-- Status Only Locks for Search/ Display Only
    getLock(classId: string, lockId: number | string, options?: ILockOptions): ILock
    getLocks(classId: string, lockIds: (number | string)[], options?: ILockOptions): ILock[]


}



//-- Interface for BOs to implement
export interface IHaveEditorLock {
    readonly EditorLock: ILock
}
